import { render } from "./ThePaymentsGenerals.vue?vue&type=template&id=0650d118"
import script from "./ThePaymentsGenerals.vue?vue&type=script&lang=js"
export * from "./ThePaymentsGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__